import React, { useEffect, useState } from 'react';
import { CustomButton, FilterBar, TableData } from 'components';
import { errorAlert } from 'helpers/alerts';
import moment from 'moment';
import { downloadProviderBalanceHistoryService, getAllProviderCredsService, getProviderBalanceHistoryService } from 'services/admin/providerService';
import { currencyFormatter, downloadFile } from 'helpers/util';
import Images from 'assets/images';
import { Box } from '@mui/material';

const ProviderBalanceHistoryScreen = () => {
  const [providerCreds, setProviderCreds] = useState(null)
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [downloadFilters, setDownloadFilters] = useState({});


  useEffect(() => {
    getAllProviderCredsService().then(creds => {
      let list = creds.filter(item => item.provider && !['smartgateiso', 'sandbox', 'certificacion'].includes(item.conciliacion_service));
      setProviderCreds(list);
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);


  const handlerSubmit = (data) => {
    setLoading(true);
    data.page = page;
    data.limit = rowsPerPage;
    setDownloadFilters(data);
    getProviderBalanceHistoryService(data).then((response) => {
      setList(response.data);
      setTotal(response.total);
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const handlerDownload = async () => {
    setLoadingDownload(true)
    downloadProviderBalanceHistoryService(downloadFilters)
      .then((data) => downloadFile(data, `Consumos de Proveedores.xlsx`))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingDownload(false));
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={rowsPerPage}
        defaultValues={{
          date: [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
        }}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            name: "cred",
            label: "Instancia",
            type: "select",
            data: providerCreds?.map(item => ({
              id: item.id,
              name: item.name_connector,
            })) || [],
            loading: providerCreds == null,
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          dataRows={list}
          total={total}
          loading={loading}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={Images.icon.download}
              key="dowloadDetails"
              name={"Descargar"}
              loading={loadingDownload}
              click={handlerDownload}
            />,
          ]}
          dataTitle={[
            "Fecha",
            "Instancia",
            "Saldo Inicial",
            "Saldo Final",
            "Abonos",
            "Consumo Proveedor",
            "Consumo HEBE",
            "Diferencia Conciliación",
          ]}
          onChangePage={page => setPage(page)}
          onChangeRowsPerPage={rowsPerPage => setRowsPerPage(rowsPerPage)}
          formatter={({ providerCred, createdAt, start_balance, end_balance, hebe_balance, abonos }) => [
            moment(createdAt).format("DD/MM/YYYY"),
            providerCred?.name_connector || '-',
            currencyFormatter.format(start_balance || 0),
            currencyFormatter.format(end_balance || 0),
            currencyFormatter.format(abonos || 0),
            end_balance == 0 ? '-' : currencyFormatter.format(Math.abs(start_balance + abonos - end_balance) || 0),
            end_balance == 0 ? '-' : currencyFormatter.format(hebe_balance || 0),
            end_balance == 0 ? '-' : currencyFormatter.format(Math.abs(Math.abs(start_balance + abonos - end_balance) - hebe_balance)),
          ]}
        />
      </Box>
    </>

  )
}

export default ProviderBalanceHistoryScreen